"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./styles.css");
var MailIcon = function (_a) {
    var style = _a.style, mailBackFoldColor = _a.mailBackFoldColor, mailTopFoldColor = _a.mailTopFoldColor, mailLeftFoldColor = _a.mailLeftFoldColor, mailRightFoldColor = _a.mailRightFoldColor, letterBackgroundColor = _a.letterBackgroundColor, letterBorderColor = _a.letterBorderColor, letterTextColor = _a.letterTextColor, shouldAnimateOpen = _a.shouldAnimateOpen, shouldAnimateDown = _a.shouldAnimateDown, shouldAnimateOnHover = _a.shouldAnimateOnHover;
    return (react_1.default.createElement("div", { style: style },
        react_1.default.createElement("div", { className: "letter-image " + (shouldAnimateOnHover ? 'shouldAnimateOnHover' : '') },
            react_1.default.createElement("div", { className: "animated-mail " + (shouldAnimateDown ? 'shouldAnimateMailDown' : '') },
                react_1.default.createElement("div", { className: "back-fold", style: { background: mailBackFoldColor } }),
                react_1.default.createElement("div", { className: "letter " + (shouldAnimateOpen ? 'shouldAnimateLetter' : ''), style: { background: letterBackgroundColor, borderColor: letterBorderColor } },
                    react_1.default.createElement("div", { className: "letter-title", style: { background: letterTextColor } }),
                    react_1.default.createElement("div", { className: "letter-subject", style: { background: letterTextColor } }),
                    react_1.default.createElement("div", { className: "letter-context", style: { background: letterTextColor } })),
                react_1.default.createElement("div", { className: "top-fold " + (shouldAnimateOpen ? 'shouldAnimateTopFold' : ''), style: { borderColor: mailTopFoldColor + " transparent transparent transparent" } }),
                react_1.default.createElement("div", { className: "left-fold", style: { borderColor: "transparent transparent transparent " + mailLeftFoldColor } }),
                react_1.default.createElement("div", { className: "right-fold", style: { borderColor: "transparent transparent " + mailRightFoldColor + " transparent" } })))));
};
MailIcon.defaultProps = {
    mailBackFoldColor: "#2874A6",
    mailTopFoldColor: "#2E86C1",
    mailLeftFoldColor: "#3498DB",
    mailRightFoldColor: "#5DADE2",
    letterBackgroundColor: "#FFFFFF",
    letterBorderColor: "#1ABC9C",
    letterTextColor: "#1ABC9C",
    shouldAnimateOpen: false,
    shouldAnimateDown: false,
    shouldAnimateOnHover: false,
};
exports.default = MailIcon;
//# sourceMappingURL=MailIcon.js.map